/** Report 2.0: main dashboard route and sub-routes (same page, optional scroll focus). */
// export const REPORT20_MAIN_PAGE = "report-20";

/** Dedicated full-page YTD budget view (dropdown). */
export const REPORT20_YTD_BUDGET_PAGE = "report-20-ytd-budget-tracking";

/** Dedicated full-page site footprint view (dropdown): baseline targets + spend mix charts. */
export const REPORT20_SITE_FOOTPRINT_PAGE = "report-20-site-footprint-changes";

/** Dedicated full-page closed site financials (monthly snapshot / blob). */
export const REPORT20_CLOSED_SITE_FINANCIALS_PAGE = "report-20-closed-sites-financials";

/** Top sites, provider donut, and category bars from live inventory only (no snapshot / invoice rollups). */
export const REPORT20_SPEND_OVERVIEW_PAGE = "report-20-spend-overview";
export const REPORT20_MRC_HISTORY_PAGE = "report-20-mrc-history";
export const REPORT20_DISCONNECTS_PAGE = "report-20-disconnects";

/** Placeholder coming-soon page (dropdown). */
export const REPORT20_WIRELESS_USAGE_PAGE = "report-20-wireless-usage";

export const REPORT20_SUB_PAGES = [
  { page: REPORT20_YTD_BUDGET_PAGE, label: "YTD Budget Tracking", focusSection: "ytdBudget", icon: "ytd" },
  { page: REPORT20_SPEND_OVERVIEW_PAGE, label: "Spend Overview", focusSection: "spendOverview", icon: "spend" },
  { page: REPORT20_MRC_HISTORY_PAGE, label: "MRC History Report", focusSection: null, icon: "history" },
  { page: REPORT20_DISCONNECTS_PAGE, label: "Disconnects", focusSection: null, icon: "disconnects" },
  { page: REPORT20_CLOSED_SITE_FINANCIALS_PAGE, label: "Coming Soon: Closed Site Financials", focusSection: null, icon: "closed" },
  { page: REPORT20_SITE_FOOTPRINT_PAGE, label: "Coming Soon: Site Footprint Changes", focusSection: "footprint", icon: "footprint" },
  { page: REPORT20_WIRELESS_USAGE_PAGE, label: "Coming Soon: Wireless Usage", focusSection: null, icon: "wireless" },
];

// export const REPORT20_ALL_PAGES = [REPORT20_MAIN_PAGE, ...REPORT20_SUB_PAGES.map((s) => s.page)];
export const REPORT20_ALL_PAGES = REPORT20_SUB_PAGES.map((s) => s.page);

// export function getReport20FocusSection(currentPage) {
//   if (currentPage === REPORT20_MAIN_PAGE) return null;
//   const sub = REPORT20_SUB_PAGES.find((s) => s.page === currentPage);
//   return sub?.focusSection ?? null;
// }
export function getReport20FocusSection(currentPage) {
  const sub = REPORT20_SUB_PAGES.find((s) => s.page === currentPage);
  return sub?.focusSection ?? null;
}

export function isReport20NavPage(currentPage) {
  return REPORT20_ALL_PAGES.includes(currentPage);
}
